//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;
// var keyElement = document.querySelector(".map-key");

// var expense = window.expenseData;
// var mode = "% of Average household budget on car-related expenses ";
// var featureLookup = {};
//
// var hsl = (h, s, l) => `hsl(${h}, ${s}%, ${l}%)`;
//
// var scale = [
//   { limit: 5, color: hsl(160, 16, 13) },
//   { limit: 10, color: hsl(190, 26, 13) },
//   { limit: 15, color: hsl(230, 36, 33) },
//   { limit: 20, color: hsl(280, 36, 33) },
//   { limit: 25, color: hsl(310, 46, 43) },
// ];
//
// // xhr("./assets/carexpense.geojson", function(err, data) {
//
// console.log(data);
//   var carexpense = L.geoJson(data);
//   carexpense.addTo(map);
//
//   var paint = function(feature) {
//   // if (year == "delta") return paintDelta(feature);
//   // if (mode == "sold") return paintSold(feature);
//   var value = feature.properties[mode] * 100;
//   var fillColor = "transparent";
//   for (var i = 0; i < scale.length; i++) {
//     var pigment = scale[i];
//     if (value <= pigment.limit) {
//       fillColor = pigment.color;
//       break;
//     }
//   }
//   console.log(value, fillColor);
//   return {
//     fillColor,
//     // stroke: false,
//     weight: 1,
//     color: "rgba(0, 0, 0, .8)",
//     fillOpacity: .7
//   }
// };
//
// carexpense.setStyle(paint);
// // xhr("./assets/car-expense.geojson", function(err, data) {
//
// //ICH code for popup template if needed----------
// // var ich = require("icanhaz");
// // var templateFile = require("./_popup.html");
// // ich.addTemplate("popup", templateFile);
//
// // var onEachFeature = function(feature, layer) {
// //   layer.bindPopup(ich.popup(feature.properties))
// // };

 map.scrollWheelZoom.disable();
 // });
